// Copy for the HostelNMC brand page, in both languages.
//
// The page is a compact hub: a title and three ways in. It has to be complete
// with an EMPTY CMS, so every string has a default here; the tagline and brand
// name are overridden by Strapi the moment an editor fills them in.
//
// Every claim has to be defensible: no ratings, no awards, no guest counts, no
// founding dates. Those belong to the owner, not to a default.
const COPY = {
  en: {
    skip: "Skip to content",
    navLabel: "Where to next",
    eyebrow: "Hostels · Indonesia",
    tagline: "Small, eco-conscious places to stay in Indonesia.",
    actions: {
      property: {
        title: "Hebe Bogor",
        body: "Our eco hostel in Bogor, West Java — rooms, rates and photos.",
      },
      guest: {
        title: "Staying with us",
        body: "Guest portal: order food, pay your deposit, manage your booking.",
      },
      insights: {
        title: "Stories & guides",
        body: "Things to do, eco tours and slow days around Bogor.",
      },
    },
    privacy: "Privacy",
    terms: "Terms",
  },

  id: {
    skip: "Lewati ke konten",
    navLabel: "Mau ke mana",
    eyebrow: "Hostel · Indonesia",
    tagline: "Penginapan kecil yang ramah lingkungan di Indonesia.",
    actions: {
      property: {
        title: "Hebe Bogor",
        body: "Hostel ramah lingkungan kami di Bogor, Jawa Barat — kamar, tarif, dan foto.",
      },
      guest: {
        title: "Sedang menginap",
        body: "Portal tamu: pesan makanan, bayar deposit, kelola pemesanan.",
      },
      insights: {
        title: "Cerita & panduan",
        body: "Aktivitas, eco tour, dan hari santai di sekitar Bogor.",
      },
    },
    privacy: "Privasi",
    terms: "Ketentuan",
  },
};

export default COPY;
